const vaults = state => state.vault_list_object
const vault = state => state.vault
const vault_token = state => state.vault_token
const vault_transactions = state => state.vault_transactions_object


export default {
  vaults,
  vault,
  vault_token,
  vault_transactions
}


// WEBPACK FOOTER //
// ./src/modules/systemStates/store/getters.js